import React from 'react'
import {actions} from 'react-redux-form'
import {toast} from 'react-toastify'
import qs from 'qs'
import irelandApi from '../irelandApi'
import store, {history} from '../store'
import ToastMessage from '../components/common/toast-message'

export const getBrands = (query) => (dispatch) => {
  dispatch({type: "GET_BRAND_LIST_PENDING"});
  const q = {
    brand: query
  };
  return irelandApi.get(`/api/admin/categories?include=brands&${qs.stringify({q: q}, {encodeValuesOnly: true})}`)
                   .then((response) => {
                     dispatch({type: "GET_BRAND_LIST_FULFILLED", payLoad: response.data});
                   })
                   .catch((error) => {
                     dispatch({type: 'GET_BRAND_LIST_REJECTED', payLoad: error.data})
                   })
};

export const getBrandsForNavbar = () => dispatch => {
  dispatch({ type: "GET_BRAND_LIST_PENDING" });
  return irelandApi.get("/api/brands")
    .then(response => dispatch({ type: "GET_BRAND_LIST_FULFILLED", payLoad: response.data }))
    .catch(error => dispatch({ type: "GET_BRAND_LIST_REJECTED", payLoad: error.data }))
}

export const reorderBrands = (id, payLoad) => (dispatch) => {
  // dispatch({type: "REORDER_BRANDS_PENDING"});
  dispatch({type: "REORDER_BRANDS_FULFILLED", payLoad: {data: payLoad, categoryId: id}});
  const data = {
    category_id: id,
    order: payLoad.map(item => +item.id)
  };
  return irelandApi.patch(`/api/admin/brands/change_order`, {brand: data})
                   .then((response) => {
                     toast.info(<ToastMessage iconStyle="info" message="Brand order modified"/>, {autoClose: 2000});
                   })
                   .catch((error) => {
                     dispatch({type: 'REORDER_BRANDS_REJECTED', payLoad: error.data});
                     toast.warn(<ToastMessage iconStyle="warning" message="Unable to set brand order"/>, {autoClose: 2000});
                   })
};

export const getBrand = (id) => (dispatch) => {
  dispatch({type: "GET_BRAND_PENDING"});
  return irelandApi.get(`/api/admin/brands/${id}`)
                   .then((response) => {
                     const attributes = response.data.data.attributes;
                     const textColour = attributes['banner-text-colour'];
                     const textColourIsHex = (''+textColour).substring(0, 1) === '#'
                     const form = {
                       name: attributes.name,
                       categories: attributes['categories'],
                       status: ''+attributes.status,
                       banner_title: attributes['banner-title'],
                       banner_text: attributes['banner-text'],
                       banner_text_colour: textColourIsHex ? 'other' : textColour,
                       banner_text_colour_custom: textColourIsHex ? textColour : undefined
                     };
                     dispatch(actions.load('deep.admin_brand', form));
                     dispatch({type: "GET_BRAND_FULFILLED", payLoad: response.data});
                   })
                   .catch((error) => {
                     dispatch({type: 'GET_BRAND_REJECTED', payLoad: error.data})
                   })
};

export const deleteBrand = (id) => (dispatch) => {
  dispatch({type: "DELETE_BRAND_PENDING"});
  return irelandApi.delete(`/api/admin/brands/${id}`)
                   .then((response) => {
                     toast.success(<ToastMessage iconStyle="success" message="Brand has been deleted successfully"/>);
                     dispatch({type: "DELETE_BRAND_FULFILLED", payLoad: id});
                   })
                   .catch((error) => {
                     toast.error(<ToastMessage iconStyle="error" message="An error occured during delete brand"/>);
                     dispatch({type: 'DELETE_BRAND_REJECTED', payLoad: error.data});
                     const data = {
                       ...error.response.data.errors
                     };
                     return Promise.reject(data);
                   })
};

const prepareBrandFormData = ({
  categories,
  banner_text_colour,
  banner_text_colour_custom,
  ...props
}) => {
  const formData = new FormData();

  for (const { value } of categories) {
    formData.append('brand[categories][]', value)
  }

  formData.append(
    'brand[banner_text_colour]',
    (banner_text_colour === 'other' ? banner_text_colour_custom : banner_text_colour) || ''
  );

  for (const [key, value] of Object.entries(props)) {
    formData.append(`brand[${key}]`, value);
  }

  return formData;
};

export const saveBrand = (payLoad) => {
  let formData = prepareBrandFormData(payLoad);
  const config = {
    headers: { 'content-type': 'multipart/form-data' }
  };
  return irelandApi.post('/api/admin/brands/', formData, config)
                   .then((response) => {
                     toast.success(<ToastMessage iconStyle="success" message="Brand has been saved successfully"/>);
                     history.push('/admin/brands');
                   })
                   .catch((error) => {
                     toast.error(<ToastMessage iconStyle="error" message="An error occurred during save brand"/>);
                     store.dispatch(actions.resetValidity('deep.admin_brand'));
                     const data = {
                       ...error.response.data.errors
                     };
                     return Promise.reject(data)
                   })
};


export const updateBrand = (id, payLoad) => {
  let formData = prepareBrandFormData(payLoad);
  const config = {
    headers: { 'content-type': 'multipart/form-data' }
  };
  return irelandApi.patch(`/api/admin/brands/${id}`, formData, config)
                   .then((response) => {
                     toast.success(<ToastMessage iconStyle="success" message="Brand has been saved successfully"/>);
                     history.push('/admin/brands');
                   })
                   .catch((error) => {
                     toast.error(<ToastMessage iconStyle="error" message="An error occurred during save brand"/>);
                     store.dispatch(actions.resetValidity('deep.admin_brand'));
                     const data = {
                       ...error.response.data.errors
                     };
                     return Promise.reject(data)
                   })
};



// WEBPACK FOOTER //
// ./src/actions/brands.js